define.alias("shared/modifiers/on-escape-key-up", "settings/modifiers/on-escape-key-up");